import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { Log } from './log.model';
import { LogService } from './log.service';

@Component({
    selector: 'dcs-log-detail',
    templateUrl: './log-detail.component.html'
})
export class LogDetailComponent implements OnInit, OnDestroy {

    log: Log;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private logService: LogService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['log']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load (id) {
        this.logService.find(id).subscribe(log => {
            this.log = log;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/log/log-detail.component.ts